import { render, staticRenderFns } from "./VendorSelector.vue?vue&type=template&id=0cd994e2&scoped=true&"
import script from "./VendorSelector.vue?vue&type=script&lang=js&"
export * from "./VendorSelector.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelector.vue?vue&type=style&index=0&id=0cd994e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd994e2",
  null
  
)

export default component.exports